import React, { useEffect, useState } from "react";
import { NavLink as RouterLink } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Button, Collapse, ListItem, makeStyles } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

const useStyles = makeStyles((theme) => ({
  item: {
    display: "block",
    paddingTop: 0,
    paddingBottom: 0,
  },
  itemLeaf: {
    display: "flex",
    paddingTop: 0,
    textTransform: "uppercase",
    paddingBottom: 0,
  },
  button: {
    alignItems: "flex-start",
    color: theme.palette.text.primary,
    fontSize: "14px",
    textTransform: "uppercase",
    padding: "13px 5px 5px 38px",
    [theme.breakpoints.down("xs")]: {
      padding: "13px 5px 5px 0px",
      "& span": {
        fontSize: "12px",
      },
    },
    justifyContent: "flex-start",
    marginBottom: "8px",
    letterSpacing: 0,
    width: "100%",
    fontWeight: "400",

    "&:hover": {
      color: theme.palette.text.secondary,
      background: "#F8F8F8",
      borderRadius: "0px",
      "& $icon": {
        // color: "#ffff",
      },
    },
  },
  collapse: {
    "& .MuiCollapse-root": {
      marginLeft: "25px",
    },
  },
  buttonLeaf: {
    color: "#262626",
    fontWeight: 700,
    padding: "13px 5px 5px 38px",
    height: "40px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    fontFamily: "poppins",
    textTransform: "uppercase",
    letterSpacing: 0,
    width: "100%",
    opacity: 1,
    fontSize: "14px",
    [theme.breakpoints.down("xs")]: {
      padding: "13px 5px 5px 0px",
      fontSize: "12px",
    },
    "& li": {
      "& $title": {
        marginLeft: "30px",
        fontSize: "14px",
        [theme.breakpoints.down("xs")]: {
          fontSize: "12px",
        },
      },
    },
    "& $icon": {
      color: "#262626",
    },
    "&:hover": {
      color: theme.palette.text.secondary,
      background: "#F8F8F8",
      borderRadius: "0px",
      "& $icon": {
        color: theme.palette.text.secondary,
      },
    },
    "& $title": {
      fontWeight: 400,
      fontSize: "14px",
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px",
      },
      // whiteSpace: "pre",
    },
  },
  icon: {
    display: "flex",
    alignItems: "center",
    marginRight: "19px",
    // color: "rgba(255, 255, 255, 0.6)",
    "&:hover": {
      color: "#000",
    },
  },
  title: {
    marginRight: "auto",
    fontSize: "14px",
    textAlign: "start",
    // color:theme.palette.text.primary,
    // fontSize:"14px",
    // fontWeight:400,
    // lineHeight:"35px",
    // textTransform:"capitalize",
  },
  active: {
    color: "#FF7F26",
    textTransform: "uppercase",
    fontWeight: 700,
    background: "#F8F8F8",
    borderLeft: "6px solid #FF7F26",
    padding: "7px 5px 7px 32px",
    marginTop: "8px !important",
    [theme.breakpoints.down("xs")]: {
      padding: "7px 5px 7px 0px",
      marginTop: "8px !important",
      border: "none",
    },
    borderRadius: "0px",
    "& $title": {
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: "14px",
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px",
      },
    },
    "& $icon": {
      color: "#FF7F26",
      "&:hover": {
        color: "#000",
      },
    },
  },
}));

const NavItem = ({
  children,
  className,
  depth,
  href,
  icon: Icon,
  info: Info,
  open: openProp,
  title,
  ...rest
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(openProp);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  useEffect(() => {
    setOpen(openProp);
  }, [openProp]);

  // let paddingLeft = 8;

  // if (depth > 0) {
  //   paddingLeft = 32 + 8 * depth;
  // }

  // const style = { paddingLeft };

  if (children) {
    return (
      <ListItem
        className={clsx(classes.item, className)}
        disableGutters
        key={title}
        {...rest}
      >
        <Button className={classes.button} onClick={handleToggle}>
          {Icon && <Icon className={classes.icon} size="20" />}
          <span className={classes.title}>{title}</span>
          {Info && <Info />}
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Button>
        <Collapse
          className={classes.collapse}
          style={{ marginLeft: "50px" }}
          in={open}
        >
          {children}
        </Collapse>
      </ListItem>
    );
  }

  return (
    <>
      {" "}
      <ListItem
        className={clsx(classes.itemLeaf, className)}
        disableGutters
        key={title}
        {...rest}
      >
        <Button
          activeClassName={classes.active}
          className={clsx(classes.buttonLeaf, `depth-${depth}`)}
          component={RouterLink}
          exact
          to={href}
        >
          {Icon && <Icon className={classes.icon} size="20" />}
          <span className={classes.title}>{title}</span>
          {Info && <Info />}
        </Button>
      </ListItem>
    </>
  );
};

NavItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  info: PropTypes.elementType,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

NavItem.defaultProps = {
  open: false,
};

export default NavItem;
